"use client"

import { MoonStar, Sun } from "lucide-react"
import { Button } from "@repo/web-ui/components/base/button"
import { useEffect, useMemo, useState } from "react"
import { useThemeMode } from "@repo/web-ui/components/theme/ThemeProvider"


interface Props {
    size?: "default" | "sm" | "lg" | "icon" | null | undefined,
    variant?: "default" | "link" | "destructive" | "outline" | "secondary" | "ghost" | null | undefined
}
const ThemeToggle = (props:Props) => {
    const { mode, toggleMode } = useThemeMode()

  return (
    <Button size={props.size} variant={props.variant} onClick={toggleMode}>
        {/* dark icon */}
        {mode === 'dark' && (
            <MoonStar className="stroke-foreground transition-colors" />
        )}
        {/* light icon */}
        {mode === 'light' && (
            <Sun className="stroke-foreground transition-colors" />
        )}
    </Button>
  )
}

export default ThemeToggle